import React from 'react';
import ArrowNarrowShortUp from '../../Assets/Dashboard/ArrowNarrowShortUp.svg';
import ArrowNarrowShortDown from '../../Assets/Dashboard/ArrowNarrowShortDown.svg';

function StatCard({ statName, statValue, hasPrice, statTrend }) {
    return (
        <div className='border border-[#EAEAEA] p-4 flex flex-col gap-[7px] rounded-lg'>
            <h2 className='font-semibold text-[14px] leading-6 text-[#666666] flex gap-1 items-baseline'>
                {statName}
                <span className='text-[12px]'>in last 7 days</span>
            </h2>

            <div className="flex items-baseline justify-between">
                <h2 className={`text-[20px] leading-8 font-semibold ${statTrend ? (statTrend > 0 ? 'text-main' : 'text-[#991B1B]') : 'text-[#121212]'}`}>{hasPrice && '₹'}{statValue}{statTrend && '%'}</h2>

                {statTrend && <div className={`rounded-xl ${statTrend > 0 ? 'bg-[#D1FAE5]' : 'bg-[#FEE2E2]'} h-fit px-[10px] py-[2px] flex items-center`}>
                    <div className="size-5 flex items-center justify-center">
                        {statTrend > 0 ? 
                            <img className='w-[10px] h-3' src={ArrowNarrowShortUp} alt="" /> :
                            <img className='w-[10px] h-3' src={ArrowNarrowShortDown} alt="" />
                        }
                    </div>

                    <h2 className={`font-semibold text-[14px] ${statTrend > 0 ? 'text-[#065F46]' : 'text-[#991B1B]'}`}>
                        {Math.abs(statTrend)}%
                    </h2>
                </div>}
            </div>
        </div>
    );
}

export default StatCard;
